//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import _ from 'lodash';
import validator from 'validator';
import dayjs from 'dayjs';
import CustomParseFormat from 'dayjs/plugin/customParseFormat';
import { tldExists } from 'tldjs';
import { v4 as uuidV4 } from 'uuid';
import LoadingOverlay from '~/components/common/LoadingOverlay.vue';
import PageHeader from '~/components/common/PageHeader';
import ProgressIndicator from '~/components/common/ProgressIndicator.vue';
import DisclosureModal from '~/components/members-area/DisclosureModal.vue';
import getPlans from '~/utils/plans';
import { generateMetaHead } from '~/utils/meta';
import { formatPhone, formatStrForFB } from '~/utils/pixel';
dayjs.extend(CustomParseFormat);
export default {
  name: 'Application',
  components: {
    LoadingOverlay,
    PageHeader,
    ProgressIndicator,
    DisclosureModal
  },
  layout: 'empty',

  asyncData({
    $cookies,
    $axios,
    route
  }) {
    // out of ordinary server-side KPI postback for PPM
    try {
      const ppmCookie = $cookies.get('FPC');

      if (ppmCookie) {
        const url = ['https://pixel.pointmediatracker.com/kpi?c=extra&kpi=applicationstart&tag_id=161&fpc=', ppmCookie, '&user_id=', '&utm_source=', route.query.utm_source || '', '&utm_medium=', route.query.g_adtype || '', '&utm_campaign=', route.query.g_campaign || '', route.query.b_campaign || ''].join('');
        console.log('PPM KPI', url);
        $axios.$get(url).then(console.log).catch(console.warn);
      }
    } catch (err) {
      console.warn('ppm: something broke', err);
    }
  },

  data() {
    return {
      loaded: false,
      processing: false,
      simplifiedMQLScreen: false,
      ageCheck: false,
      ageCheckDate: null,
      eSign: false,
      eSignDate: null,
      smsConsent: true,
      smsConsentDate: new Date(),
      first_name: '',
      last_name: '',
      phone: '',
      email: '',
      date_of_birth: '',
      blurredFields: {},
      shakeForm: {},
      showError: false,
      errorMsgs: [],
      showDisclosure: false,
      disclosureFile: '',
      viewDisclosure: {
        Extra_Electronic_Communications_Agreement: false
      },
      checkboxSegmentFlag: false,
      mqlStartedSegmentFlag: false
    };
  },

  head() {
    return generateMetaHead({
      title: 'Apply Now | Extra',
      description: 'Apply now for an Extra debit card with no credit check. Start building your credit while paying no interest and racking up debit card points!',
      bodyAttrs: {
        class: this.$exp.$classes.join(' ')
      }
    });
  },

  computed: {
    alternateFunnel() {
      return 'pricing-test-jan-2023';
    },

    plans() {
      return getPlans(this.alternateFunnel);
    },

    checked() {
      if (this.simplifiedMQLScreen) return true;
      return this.ageCheck && this.eSign;
    },

    formattedBirthday() {
      if (!this.simplifiedMQLScreen) return null; // the third argument checks that the value is a valid date: https://day.js.org/docs/en/parse/is-valid

      const parsed = dayjs(this.date_of_birth, 'MM/DD/YYYY', true);
      const val = this.date_of_birth && this.date_of_birth.length === 10 && parsed && parsed.isValid() && dayjs().diff(parsed, 'years') < 99 && parsed.format('YYYY-MM-DD');

      if (!val || val === '') {
        return null;
      }

      return val;
    },

    isUnder18() {
      return this.formattedBirthday && dayjs().diff(this.formattedBirthday, 'years') < 18;
    },

    formErrors() {
      return {
        email: _.isEmpty(this.email) || !validator.isEmail(this.email) || !tldExists(this.email),
        phone: _.isEmpty(this.phone) || !validator.isMobilePhone(`${this.phone}`.replace('-', ''), 'any', {
          strictMode: false
        }) || this.phone.length < 10,
        first_name: _.isEmpty(this.first_name),
        last_name: _.isEmpty(this.last_name),
        ...(this.simplifiedMQLScreen && {
          date_of_birth: !this.formattedBirthday || this.isUnder18
        })
      };
    },

    showFormError() {
      return Object.keys(this.formErrors).reduce((obj, key) => {
        obj[key] = Boolean(this.blurredFields[key] && this.formErrors[key]);
        return obj;
      }, {});
    },

    readyToSubmit() {
      return Object.values(this.formErrors).every(val => !val) && this.checked;
    }

  },
  watch: {
    loaded(val) {
      if (!val) {
        return;
      }

      window.extra_data_ul.log([{
        app: 'sales-funnel',
        kingdom: 'prequal_start'
      }]);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: '050_prequal_start'
      });

      if (window.branch) {
        window.branch.setIdentity(window.g_user_tag);
        window.branch.logEvent('debit application started', {
          user_tag: window.g_user_tag
        }, err => {
          if (err) {
            this.$sentry.captureException(err);
          }
        });
      }

      this.$segment.track('MQL Viewed', {
        event_datetime: new Date().toISOString()
      });
    },

    ageCheck(val) {
      this.ageCheckDate = val ? new Date() : null;

      if (!this.checkboxSegmentFlag) {
        this.$segment.track('MQL Continued', {
          event_datetime: new Date().toISOString()
        });
        this.checkboxSegmentFlag = true;
      }
    },

    eSign(val) {
      this.eSignDate = val ? new Date() : null;

      if (!this.checkboxSegmentFlag) {
        this.$segment.track('MQL Continued', {
          event_datetime: new Date().toISOString()
        });
        this.checkboxSegmentFlag = true;
      }
    },

    smsConsent(val) {
      this.smsConsentDate = val ? new Date() : null;
    }

  },

  beforeMount() {
    // If an anonymous identifier is passed in as a query parameter
    // we will set it to the default segment identifier
    const {
      anonymousId
    } = this.$route.query;

    if (anonymousId) {
      this.$segment.setAnonymousId(anonymousId);
    } // Remove anonymousId from query parameter string, if supplied


    this.$router.replace({
      query: { ...this.$route.query,
        anonymousId: undefined
      }
    });
  },

  mounted() {
    if (this.$config.environment !== 'production') console.log('[experiment]', this.$exp);
    if (this.alternateFunnel) window.ga('set', 'dimension1', this.alternateFunnel);
    this.simplifiedMQLScreen = this.$growthbook.isFeatureOn('mtc-simplify-mql-page'); // Adding primarily to mark Datadog syntehtic test runner traffic

    if (window.navigator.userAgent === 'Datadog/Synthetics') {
      this.$segment.identify({
        traits: {
          is_demo: true
        }
      });
    }
  },

  methods: {
    showThisDisclosure(disc) {
      this.disclosureFile = disc;
      this.showDisclosure = true;
    },

    viewedDisclosure(disclosure) {
      this.showDisclosure = false;
      this.viewDisclosure[disclosure] = true;
    },

    submit(e) {
      e.preventDefault();

      if (this.processing) {
        return;
      }

      let hasFormErrors = false;
      Object.entries(this.formErrors).forEach(([name, isError]) => {
        if (isError) {
          this.onFieldBlur(name);
          hasFormErrors = true;
        }
      });
      if (hasFormErrors) return;

      if (!this.checked) {
        alert('Please make sure you have filled out the checkboxes.');
        return;
      }

      const submitDate = new Date();

      if (this.simplifiedMQLScreen) {
        this.eSignDate = submitDate;
        this.ageCheckDate = submitDate;
      }

      const urlParams = new URLSearchParams(location.search);
      const payload = {
        first_name: this.first_name,
        last_name: this.last_name,
        phone: this.phone.replace(/[^\d+]/g, ''),
        email: this.email.trim(),
        user_tag: window.g_user_tag,
        device_tag: window.g_device_tag,
        query: this.$route.query,
        e_sign: this.eSignDate,
        age_check: this.ageCheckDate,
        extra_tos: submitDate,
        extra_privacy: submitDate,
        evolve_privacy: submitDate,
        ...(this.simplifiedMQLScreen ? {
          date_of_birth: this.formattedBirthday
        } : {
          sms_consent: this.smsConsentDate
        }),
        ef_aff_id: urlParams.get('affid') || urlParams.get('aff_id') || this.$cookies.get('extra_ef_affid'),
        ef_click_id: urlParams.get('_ef_transaction_id') || window.EF && window.EF.getAdvertiserTransactionId(1)
      };
      if (this.alternateFunnel) payload.experiments = [this.alternateFunnel];
      this.processing = true;
      this.showError = false;
      this.errorMsgs = [];
      this.$axios.$post('/api/prequal', payload).then(data => {
        if (data.error) {
          this.processing = false;
          this.showError = true;
          this.errorMsgs = data.error;
          return;
        }

        console.log('success', data);
        window.extra_data_ul.log([{
          app: 'sales-funnel',
          kingdom: 'prequal_complete',
          phylum: 'success'
        }]);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: '059_prequal_complete',
          email: payload.email,
          phone: payload.phone
        });
        const seg_trait_age = this.simplifiedMQLScreen && dayjs().diff(dayjs(this.date_of_birth), 'year');
        this.$segment.identify(data.memberId, {
          firstName: payload.first_name,
          lastName: payload.last_name,
          email: payload.email,
          phone: payload.phone,
          ...(seg_trait_age && {
            age: seg_trait_age,
            birthday: this.date_of_birth
          })
        });
        this.$segment.track('MQL Completed'); // Browser FB Lead event

        const eventID = uuidV4();
        const userData = {
          fn: payload.first_name,
          ln: payload.last_name,
          em: payload.email,
          ph: formatStrForFB(formatPhone(payload.phone))
        };
        this.$fb.track('Lead', userData, {
          eventID
        });
        const member = {
          id: data.memberId,
          first_name: payload.first_name,
          last_name: payload.last_name,
          email: payload.email,
          phone: payload.phone,
          ...(this.simplifiedMQLScreen && {
            date_of_birth: this.formattedBirthday
          }),
          external_id: this.$cookies.get('ajs_anonymous_id')
        };
        this.$axios.$post('/api/fbevent', {
          eventName: 'Lead',
          member,
          eventId: eventID
        }).catch(err => {
          console.log(`[fbEvent] Lead CAPI failed for mid: ${member.id} with error: ${err}`);
        }); // show the step on the login page next time it opens

        window.sessionStorage.setItem('funnel-steps-progression-login', true);
        this.$router.push({
          path: '/members/login',
          query: { ...this.$route.query,
            phone: payload.phone
          }
        });
      }).catch(() => {
        this.processing = false;
        window.alert('Something went wrong, please try again. Make sure you entered a correct phone number');
        window.extra_data_ul.log([{
          app: 'sales-funnel',
          kingdom: 'prequal_complete',
          phylum: 'fail'
        }]);
      });
    },

    onFieldFocus(name) {},

    onFieldBlur(name) {
      this.$set(this.blurredFields, name, true);

      if (this.formErrors[name] && !!this[name]) {
        this.$set(this.shakeForm, name, true);
        setTimeout(() => {
          this.$set(this.shakeForm, name, false);
        }, 450);
      }
    },

    onFieldChange(name) {
      if (!this.mqlStartedSegmentFlag) {
        this.$segment.track('MQL Continued');
        this.mqlStartedSegmentFlag = true;
      }

      this.showError = false;
    }

  }
};